import React, { useState } from 'react';

// Components
import Bet from './bet';
import BookieSelection from './bookie-selection';
import BookieSelector from './bookie-selector';

// Interfaces
import type IBet from '../interfaces/IBet';
import type IBookieOdds from '../interfaces/IOdds';

import styles from '../style/multi-betslip.module.css';

interface IProps {
  bets: IBet[];
  bookieOdds: IBookieOdds[];
  removeBet: (betId: number, disabled?: boolean) => void;
  selectedBookie: IBookieOdds;
  setStake: (stake: number) => void;
  stake: number;
}

function MultiBetslip({
  bets,
  bookieOdds,
  removeBet,
  selectedBookie,
  setStake,
  stake
}: IProps): JSX.Element {
  const [betIds, setBetIds] = useState<number[]>([]);

  React.useEffect(() => {
    setBetIds(bets.map((bet) => bet.betId));
  }, [bets]);

  function renderBets(): JSX.Element[] {
    return bets.
    map((bet) => {
      const disabled =
      selectedBookie && !selectedBookie.betIds?.includes(bet.betId);
      return (
        <Bet
          bet={bet}
          disabled={disabled}
          key={bet.betId}
          removeBet={removeBet} />);


    }).
    sort((a, b) => a.props.disabled - b.props.disabled);
  }

  return (
    <div className={styles.multiBetslipWrapper}>
			<div className={styles.selectedBookie}>
				<div className={styles.bookie}>
					<BookieSelection
            betIds={betIds}
            changeStake={setStake}
            selection={selectedBookie}
            selected
            stake={stake} />

				</div>
			</div>

			<div className={styles.scrollWrapper}>
				{renderBets()}
				{bookieOdds.length > 1 &&
        <BookieSelector
          betIds={betIds}
          bookies={bookieOdds}
          selectedBookie={selectedBookie}
          stake={stake} />

        }
			</div>
		</div>);

}

export default MultiBetslip;